// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "backButton-1sp-T";
var _3 = "button-17Iei";
export { _1 as "__esModule", _2 as "backButton", _3 as "button" }
export default { "__esModule": _1, "backButton": _2, "button": _3 }
